export const BOTTOM_BAR_BUTTONS = {
    cart: 'cart',
    catalog: 'catalog',
    favorite: 'favorite',
    main: 'main',
    profile: 'profile',
} as const;
